import { render, staticRenderFns } from "./ReviewInput.vue?vue&type=template&id=91444842&scoped=true"
import script from "./ReviewInput.vue?vue&type=script&lang=js"
export * from "./ReviewInput.vue?vue&type=script&lang=js"
import style0 from "./ReviewInput.vue?vue&type=style&index=0&id=91444842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91444842",
  null
  
)

export default component.exports